
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              離海5min b&b
            </h3>
            <p className="text-gray-400 leading-relaxed">
              位於屏東恆春的歐美風格小木屋，鄰近沙灘，環境優美，人少幽靜，是您遠離塵囂的最佳選擇。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">快速連結</h4>
            <div className="space-y-2">
              <a href="#rooms" className="block hover:text-teal-400 transition-colors cursor-pointer">房型介紹</a>
              <a href="#about" className="block hover:text-teal-400 transition-colors cursor-pointer">關於我們</a>
              <a href="#contact" className="block hover:text-teal-400 transition-colors cursor-pointer">聯絡我們</a>
              <a 
                href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:text-teal-400 transition-colors cursor-pointer"
              >
                立即預訂
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">聯絡資訊</h4>
            <div className="space-y-3">
              <a href="http://maps.google.com/maps?q=946台灣屏東縣恆春鎮下泉路49-3號" target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-map-pin-line text-xl flex-shrink-0 mt-1"></i>
                <span>946台灣屏東縣恆春鎮下泉路49-3號</span>
              </a>
              <a href="tel:0908-162292" className="flex items-center gap-2 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
                <span>0908-162292</span>
              </a>
              <a href="mailto:2019oceandreamer@gmail.com" className="flex items-center gap-2 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
                <span>2019oceandreamer@gmail.com</span>
              </a>
            </div>
            
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.facebook.com/people/%E9%9B%A2%E6%B5%B75min-bb/61559543212238/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/5min_to_sea_bnb/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-teal-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a 
                href="https://lin.ee/i6pwzIh"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} 離海5min b&b. All rights reserved. | 統一編號: 83738429
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
